import React, {useRef} from 'react'
import store from "@formAppHome/store"
import {useTranslation} from 'react-i18next'

export default({field: {name, value, onChange, onBlur}, form}) => {
  const {t} = useTranslation();
  const {domainsList, formValues} = React.useContext(store);

  const [timer, setTimer] = React.useState(null);

  const textInputDomainSearch = useRef(null);

  React.useEffect(() => {
    const savedValue = formValues.getValue(name);
    if (savedValue) {
      form.setFieldValue(name, savedValue);
    }
  }, []);

  function handleClick() {
    clearTimeout(timer);
    const error = form.errors[name];
    if (error) return;
    domainsList.clear();
    domainsList.clear2();
    domainsList.clear3();

    if (textInputDomainSearch.current.value.length < 3) return;

    domainLookup();

    dataLayer.push({
      event: 'internal_search',
      eventCategory: 'Domain search',
      eventAction: 'manual',
      eventLabel: value,
    });
  }

  function clearField() {
    clearTimeout(timer);
    domainsList.clear();
    domainsList.clear2();
    domainsList.clear3();
    domainsList.setSecondarySearch('idle');
    domainsList.setSearch('idle');
    form.setFieldValue(name, '');
    form.setFieldTouched(name, false);
  }

  function handleKeyPress(e) {
    if (e.charCode === 13) {
      e.preventDefault();
      handleClick();
    }
  }

  const handleChange = async (e) => {
    clearTimeout(timer);
    form.setFieldTouched(name);
    await onChange(e);
    const errors = await form.validateForm();
    const value = e.target.value;
    setTimer(setTimeout(() => {
      if (!errors[name]) {
        domainsList.clear();
        domainsList.clear2();
        domainsList.clear3();

        if (textInputDomainSearch.current.value.length > 2) {
          domainLookup(value);

          dataLayer.push({
            event: 'internal_search',
            eventCategory: 'Domain search',
            eventAction: 'auto',
            eventLabel: value,
          });
        }
      }
    }, 2000));
  };

  const fetchThirdLevelDomain = async (siteName) => {
    const searchString = siteName.substring(0,24);
    const response = await fetch(`https://aa.altervista.org/ajax-check-username.php?rt=json&u=${searchString}`);
    const data = await response.json();
    if (!data.valid) {
      // todo: gestione errore
      return false
    }
    if (!data.success) {
      // todo: gestione insuccesso - reiterazione?
      return false
    }
    domainsList.setThirdLevel({
      name: searchString,
      domain: domainsList.groupDomain,
      isAvailable: data.available,
      yearPrice: 0,
      finalPrice: 0,
      price: 0
    });
    return data;
  };
  
  const fetchSecondLevels = async (siteName, matchTld = null) => {

    if (matchTld != null) matchTld = matchTld[0].replace('.','')

    const results = await Promise.allSettled(
      domainsList.primaryTld.map( async tld => {
        const response = await fetch(`https://aa.altervista.org/ajax-domain.php?action=lookup&domain=${siteName}&tld=${tld.name}`);
        const data = await response.json();
        if (data.success && tld.name != matchTld) {
          const entry = {
            name: siteName,
            domain: `.${tld.name}`,
            isAvailable: data.available,
            yearPrice: tld.yearPrice,
            finalPrice: tld.finalPrice,
            price: tld.price
          };
          (data.available) ? domainsList.addToHead(entry) : domainsList.addToTail(entry);
        }
        return data;
      })
    );
    return results;
  };

  const fetchDomainWithTld = async (siteName, tld) => {
    
    tld = tld[0].replace('.','')

    var tldData = Object.values(domainsList.primaryTld).filter(obj => obj.name == tld)
    if (!tldData.length) tldData = Object.values(domainsList.secondaryTld).filter(obj => obj.name == tld)
    
    const response = await fetch(`https://aa.altervista.org/ajax-domain.php?action=lookup&domain=${siteName}&tld=${tld}`);
    const data = await response.json();
    if (data.success) {
      const entry = {
        name: siteName,
        domain: `.${tldData[0].name}`,
        isAvailable: data.available,
        transfer: data.transfer,
        yearPrice: tldData[0].yearPrice,
        finalPrice: tldData[0].finalPrice,
        price: tldData[0].price
      };
      domainsList.clear3();
      domainsList.addToHead3(entry);
    }
    return data;
  };

  const domainLookup = async(domain = '') => {
    if (form.errors[name]) return;
    if (domain) value = domain;
    value.toLowerCase();
    const wwwRegex = /^(www\.)/;
    const tldRegex = /(\.[a-z]+)+$/;
    let matchTld;

    if (wwwRegex.test(value)) {
      value = value.replace(wwwRegex, '');
    }
    
    if (tldRegex.test(value)) {
      matchTld = value.match(tldRegex);
      value = value.replace(tldRegex, '');
    }
    
    domainsList.setRequestedTld(domainsList.groupDomain);
    formValues.setValue(name, value);
    domainsList.setSearch('started');
    domainsList.setSecondarySearch('idle');

    /*let allPromises = [
      fetchThirdLevelDomain(value),
      fetchSecondLevels(value, matchTld)
    ];*/

    //fetchThirdLevelDomain(value),
    //fetchSecondLevels(value, matchTld)

    if (matchTld) {
      await fetchDomainWithTld(value, matchTld);
    }

    let res = await Promise.allSettled([
      await fetchThirdLevelDomain(value),
      await fetchSecondLevels(value, matchTld)
    ]);

    domainsList.setSearch('finished');
  };

  return (
    <div className={`formGroup${(form.touched[name] && form.errors[name]) ? ' error' : ''}`}>
      <div className="formField --siteName">
        {window.groupDomain &&
        <div className='formField-append'>{window.groupDomain}</div>
        }
        <input type='text'
               name={name}
               ref={textInputDomainSearch}
               value={value}
               onBlur={onBlur}
               maxLength='63'
               onChange={handleChange}
               onKeyPress={handleKeyPress}
               placeholder={t('Scegli il nome')}
               disabled={(domainsList.searchState === 'started' || domainsList.secondarySearchState === 'started')}
               //autoFocus
        />
        <button className="btn--search" type="button" onClick={handleClick}>
          <span className='altervista-icon icon-search'></span>
        </button>
        {value &&
        <button className='btn--clearField' type='button' onClick={clearField}>
        </button>
        }
      </div>
      <div className="errorMessage">{form.errors[name]}</div>
    </div>
  )
}